module.exports = __webpack_public_path__ + "img/rec-main-upArrow.71c7abe9.svg";